import { InjectionToken } from '@angular/core';
import { BuildEnvironment } from '@shared/models';

export interface AppConfig {
  name: BuildEnvironment;
  apiHost: string;
  firebase: Record<string, string>;
  production: boolean;
}

export const APP_ENV_CONFIG = new InjectionToken<AppConfig>('Application Environment Config');

export const getEnvironment = (): AppConfig => {
  switch (window.location.host) {
    case 'admin.rocketkor.net':
    case 'operations.rocketkor.net':
      return {
        name: 'production',
        production: true,
        apiHost: 'https://internal.rocketkor.net',
        firebase: {
          apiKey: 'AIzaSyBDEOc0RIKRGpFaktA8GmbuLOzWp-XQhms',
          authDomain: 'prod-rocketkor-control-plane.firebaseapp.com',
          projectId: 'prod-rocketkor-control-plane',
          storageBucket: 'prod-rocketkor-control-plane.appspot.com',
          messagingSenderId: '1001716147633',
          appId: '1:1001716147633:web:431f5374f97f3370558990',
          measurementId: 'G-707TY2FRL1',
        },
      };
    case 'admin.salttreasury.com':
      return {
        name: 'production',
        production: true,
        apiHost: 'https://internal.salttreasury.com',
        firebase: {
          apiKey: 'AIzaSyBDEOc0RIKRGpFaktA8GmbuLOzWp-XQhms',
          authDomain: 'prod-rocketkor-control-plane.firebaseapp.com',
          projectId: 'prod-rocketkor-control-plane',
          storageBucket: 'prod-rocketkor-control-plane.appspot.com',
          messagingSenderId: '1001716147633',
          appId: '1:1001716147633:web:431f5374f97f3370558990',
          measurementId: 'G-707TY2FRL1',
        },
      };
    case 'admin.sandbox.rocketkor.net':
    case 'operations.sandbox.rocketkor.net':
      return {
        name: 'sandbox',
        production: true,
        apiHost: 'https://internal.sandbox.rocketkor.net',
        firebase: {
          apiKey: 'AIzaSyBOY24QQ23iRbxnekMVVfVcY6nDEWtIJFE',
          authDomain: 'cs-rocketkor-control-plane.firebaseapp.com',
          projectId: 'cs-rocketkor-control-plane',
          storageBucket: 'cs-rocketkor-control-plane.appspot.com',
          messagingSenderId: '646060919846',
          appId: '1:646060919846:web:2049dfedcd39e2d5392ae7',
          measurementId: 'G-PE2ZXRZGF2',
        },
      };
    case 'admin.sandbox.salttreasury.com':
      return {
        name: 'sandbox',
        production: true,
        apiHost: 'https://internal.sandbox.salttreasury.com',
        firebase: {
          apiKey: 'AIzaSyBOY24QQ23iRbxnekMVVfVcY6nDEWtIJFE',
          authDomain: 'cs-rocketkor-control-plane.firebaseapp.com',
          projectId: 'cs-rocketkor-control-plane',
          storageBucket: 'cs-rocketkor-control-plane.appspot.com',
          messagingSenderId: '646060919846',
          appId: '1:646060919846:web:2049dfedcd39e2d5392ae7',
          measurementId: 'G-PE2ZXRZGF2',
        },
      };
    case 'admin.staging.rocketkor-nonprod.net':
    case 'operations.staging.rocketkor-nonprod.net':
      return {
        name: 'staging',
        production: false,
        apiHost: 'https://internal.staging.rocketkor-nonprod.net',
        firebase: {
          apiKey: 'AIzaSyBEQsIPlmy2d1UwANCSjyiLZHTh8NXzt2Q',
          authDomain: 'staging-rocketkor-controlplane.firebaseapp.com',
          projectId: 'staging-rocketkor-controlplane',
          storageBucket: 'staging-rocketkor-controlplane.firebasestorage.app',
          messagingSenderId: '722631436856',
          appId: '1:722631436856:web:dad01381dfb88283efd4cd',
          measurementId: 'G-03JNFK29M1',
        },
      };
    case 'admin.staging.salttreasury.com':
      return {
        name: 'staging',
        production: false,
        apiHost: 'https://internal.staging.salttreasury.com',
        firebase: {
          apiKey: 'AIzaSyBEQsIPlmy2d1UwANCSjyiLZHTh8NXzt2Q',
          authDomain: 'staging-rocketkor-controlplane.firebaseapp.com',
          projectId: 'staging-rocketkor-controlplane',
          storageBucket: 'staging-rocketkor-controlplane.firebasestorage.app',
          messagingSenderId: '722631436856',
          appId: '1:722631436856:web:dad01381dfb88283efd4cd',
          measurementId: 'G-03JNFK29M1',
        },
      };
    case 'rocketkor-qa-admin-portal.web.app':
    case 'rocketkor-qa-admin-portal.firebaseapp.com':
    case 'admin.qa.rocketkor-nonprod.net':
    case 'operations.qa.rocketkor-nonprod.net':
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://internal.qa.rocketkor-nonprod.net',
        firebase: {
          apiKey: 'AIzaSyDdec5TvO4jV9B457yUzHO1hCdeBv8OCCw',
          authDomain: 'qa-rocketkor-control-pla-81b57.firebaseapp.com',
          projectId: 'qa-rocketkor-control-pla-81b57',
          storageBucket: 'qa-rocketkor-control-pla-81b57.appspot.com',
          messagingSenderId: '557369186488',
          appId: '1:557369186488:web:d0c09fb4a8f75305083c4d',
        },
      };
    case 'admin.qa.salttreasury.com':
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://internal.qa.salttreasury.com',
        firebase: {
          apiKey: 'AIzaSyDdec5TvO4jV9B457yUzHO1hCdeBv8OCCw',
          authDomain: 'qa-rocketkor-control-pla-81b57.firebaseapp.com',
          projectId: 'qa-rocketkor-control-pla-81b57',
          storageBucket: 'qa-rocketkor-control-pla-81b57.appspot.com',
          messagingSenderId: '557369186488',
          appId: '1:557369186488:web:d0c09fb4a8f75305083c4d',
        },
      };
    case 'rocketkor-dev-admin-portal.web.app':
    case 'rocketkor-dev-admin-portal.firebaseapp.com':
    case 'admin.dev.rocketkor-nonprod.net':
    case 'operations.dev.rocketkor-nonprod.net':
      return {
        name: 'develop',
        production: false,
        apiHost: 'https://internal.dev.rocketkor-nonprod.net',
        firebase: {
          apiKey: 'AIzaSyDWT2-sUzUMSrv2hip4hw1f5i2uxQL-vV4',
          authDomain: 'dev-rocketkor-control-plane.firebaseapp.com',
          projectId: 'dev-rocketkor-control-plane',
          storageBucket: 'dev-rocketkor-control-plane.appspot.com',
          messagingSenderId: '255211785740',
          appId: '1:255211785740:web:b8071804756749cbace829',
        },
      };
    default:
      return {
        name: 'qa',
        production: false,
        apiHost: 'https://internal.qa.rocketkor-nonprod.net',
        firebase: {
          apiKey: 'AIzaSyDdec5TvO4jV9B457yUzHO1hCdeBv8OCCw',
          authDomain: 'qa-rocketkor-control-pla-81b57.firebaseapp.com',
          projectId: 'qa-rocketkor-control-pla-81b57',
          storageBucket: 'qa-rocketkor-control-pla-81b57.appspot.com',
          messagingSenderId: '557369186488',
          appId: '1:557369186488:web:d0c09fb4a8f75305083c4d',
        },
      };
  }
};
